import { isObject, isFunction } from 'lodash';

/**
 * 自定义插件数组
 */
const customPlugins = [];

/**
 * 是否为合法的自定义插件
 * @param {*} plugin
 */
const isValidPlugin = plugin => {
  return isObject(plugin) && isFunction(plugin.install);
};

/**
 * 注册自定义插件
 * @param {*} plugin
 * @param {*} position
 */
const registerPlugin = (plugin, opt = {}) => {
  const { position = 'end' } = opt;

  if (!isValidPlugin(plugin)) {
    return;
  }

  if (customPlugins.includes(plugin)) {
    return;
  }

  if (position === 'front') {
    customPlugins.unshift(plugin);
  } else {
    customPlugins.push(plugin);
  }

  return () => unregisterPlugin(plugin);
};

/**
 * 移除自定义插件
 * @param {*} plugin
 */
const unregisterPlugin = plugin => {
  const i = customPlugins.indexOf(plugin);
  if (i > -1) customPlugins.splice(i, 1);
};

/**
 * 批量添加自定义插件
 * @param  {...any} args
 */
const use = (...args) => args.forEach(registerPlugin);

export default use;

export { customPlugins, registerPlugin, unregisterPlugin };



// WEBPACK FOOTER //
// ./~/vue-xpc/src/interface.js